exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-popper {\r\n  z-index: 9999 !important;\n}\r\n", ""]);

// exports
